import { apiGet, apiPut } from "./http";
import type { AssocBasicInfo } from "../pages/admin/utils/basicInfoStore";

export interface TenantProfileDto {
  name: string;
  shortName: string;
  founded: string;
  description: string;
  mission: string;
  slogan: string;
  phone: string;
  email: string;
  address: string;
  addressProvince?: string;
  addressCity?: string;
  addressDistrict?: string;
  addressDetail?: string;
  province?: string;
  city?: string;
  district?: string;
  regionCode?: string;
  website: string;
  wechat: string;
  weibo: string;
  douyin: string;
  xiaohongshu: string;
  bilibili: string;
  twitter: string;
  assocType: string;
  certNumber: string;
  coverCity: string;
  memberCount: number;
  logoUrl: string;
  bannerUrl: string;
  enrollmentPayee: string;
  enrollmentBankName: string;
  enrollmentBankAccount: string;
  enrollmentTransferNote: string;
  /** 0=上传缴费凭证；1=微信小程序在线支付（服务商子商户） */
  enrollmentFeeCollectMode?: number;
  /** 入会协议 PDF 用电子章图（上传后 OSS URL） */
  enrollmentAgreementSealUrl?: string;

  /** 资讯图片上传大小上限（MB）；0=按系统默认 */
  newsImageUploadMaxMb?: number;
  /** 资讯视频上传大小上限（MB）；0=按系统默认 */
  newsVideoUploadMaxMb?: number;
}

import { composeChinaAddress } from "../utils/chinaAddress";

export function assocBasicInfoFromApi(d: TenantProfileDto): AssocBasicInfo {
  const addressDetail = (d.addressDetail ?? "").trim() || (d.address ?? "").trim();
  return {
    name: d.name,
    shortName: d.shortName,
    founded: d.founded,
    description: d.description,
    mission: d.mission,
    slogan: d.slogan,
    phone: d.phone,
    email: d.email,
    address: d.address,
    addressProvince: (d.addressProvince ?? "").trim(),
    addressCity: (d.addressCity ?? "").trim(),
    addressDistrict: (d.addressDistrict ?? "").trim(),
    addressDetail,
    website: d.website,
    wechat: d.wechat,
    weibo: d.weibo,
    douyin: d.douyin,
    xiaohongshu: d.xiaohongshu,
    bilibili: d.bilibili,
    twitter: d.twitter,
    assocType: d.assocType,
    certNumber: d.certNumber,
    coverCity: d.coverCity,
    memberCount: d.memberCount,
    logoUrl: d.logoUrl ?? "",
    bannerUrl: d.bannerUrl ?? "",
    enrollmentPayee: d.enrollmentPayee ?? "",
    enrollmentBankName: d.enrollmentBankName ?? "",
    enrollmentBankAccount: d.enrollmentBankAccount ?? "",
    enrollmentTransferNote: d.enrollmentTransferNote ?? "",
    enrollmentFeeCollectMode: d.enrollmentFeeCollectMode ?? 0,
    enrollmentAgreementSealUrl: d.enrollmentAgreementSealUrl ?? "",
    newsImageUploadMaxMb: Number(d.newsImageUploadMaxMb ?? 0) || 0,
    newsVideoUploadMaxMb: Number(d.newsVideoUploadMaxMb ?? 0) || 0,
  };
}

export function tenantProfileDtoFromAssoc(a: AssocBasicInfo): TenantProfileDto {
  const address = composeChinaAddress(
    a.addressProvince,
    a.addressCity,
    a.addressDistrict,
    a.addressDetail,
  );
  return {
    name: a.name,
    shortName: a.shortName,
    founded: a.founded,
    description: a.description,
    mission: a.mission,
    slogan: a.slogan,
    phone: a.phone,
    email: a.email,
    address,
    addressProvince: a.addressProvince,
    addressCity: a.addressCity,
    addressDistrict: a.addressDistrict,
    addressDetail: a.addressDetail,
    website: a.website,
    wechat: a.wechat,
    weibo: a.weibo,
    douyin: a.douyin,
    xiaohongshu: a.xiaohongshu,
    bilibili: a.bilibili,
    twitter: a.twitter,
    assocType: a.assocType,
    certNumber: a.certNumber,
    coverCity: a.coverCity,
    memberCount: a.memberCount,
    logoUrl: a.logoUrl ?? "",
    bannerUrl: a.bannerUrl ?? "",
    enrollmentPayee: a.enrollmentPayee ?? "",
    enrollmentBankName: a.enrollmentBankName ?? "",
    enrollmentBankAccount: a.enrollmentBankAccount ?? "",
    enrollmentTransferNote: a.enrollmentTransferNote ?? "",
    enrollmentFeeCollectMode: a.enrollmentFeeCollectMode ?? 0,
    enrollmentAgreementSealUrl: a.enrollmentAgreementSealUrl ?? "",
    newsImageUploadMaxMb: Number(a.newsImageUploadMaxMb ?? 0) || 0,
    newsVideoUploadMaxMb: Number(a.newsVideoUploadMaxMb ?? 0) || 0,
  };
}

export function fetchTenantProfile(tenantLegacyId: string) {
  return apiGet<TenantProfileDto>(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/tenant-profile`);
}

export function putTenantProfile(tenantLegacyId: string, body: TenantProfileDto) {
  return apiPut<TenantProfileDto>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/tenant-profile`,
    body,
  );
}
